module.exports = __webpack_public_path__ + "static/media/page-builder-1.e789dd99.png";